jQuery(($) => {
	const LIST_SELECTOR = '.m-basic-slider__list';
	let listenerId = 0;

	const resolveElements = (target) => {
		if (!target) {
			return [];
		}

		if (typeof target === 'string') {
			return $(target).toArray();
		}

		if (target instanceof Element) {
			return [target];
		}

		if (target.jquery) {
			return target.toArray();
		}

		if (Array.isArray(target) || target instanceof NodeList) {
			return Array.from(target).filter((element) => element instanceof Element);
		}

		return [];
	};

	const createViewportOverflowListener = (target, options = {}) => {
		const settings = {
			onChange: null,
			logWhenOverflowing: false,
			...options,
		};
		const namespace = `.basicSliderOverflow${listenerId += 1}`;
		let frameId = null;

		const checkOverflow = () => {
			frameId = null;
			const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
			const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
			const elements = resolveElements(target);

			elements.forEach((element, index) => {
				const rect = element.getBoundingClientRect();
				const isOverflowingViewport =
					rect.left < 0 ||
					rect.right > viewportWidth ||
					rect.top < 0 ||
					rect.bottom > viewportHeight;

				if (settings.logWhenOverflowing && isOverflowingViewport) {
					console.log('[basic-slider] .m-basic-slider__list is overflowing off the viewport', {
						index,
						rect,
					});
				}

				if (typeof settings.onChange === 'function') {
					settings.onChange({
						element,
						index,
						rect,
						isOverflowingViewport,
						viewportWidth,
						viewportHeight,
					});
				}
			});
		};

		const scheduleOverflowCheck = () => {
			if (frameId !== null) {
				cancelAnimationFrame(frameId);
			}

			frameId = requestAnimationFrame(checkOverflow);
		};

		$(window).on(`load${namespace} resize${namespace} orientationchange${namespace}`, scheduleOverflowCheck);
		scheduleOverflowCheck();

		return {
			check: scheduleOverflowCheck,
			removeListener: () => {
				$(window).off(`load${namespace} resize${namespace} orientationchange${namespace}`, scheduleOverflowCheck);

				if (frameId !== null) {
					cancelAnimationFrame(frameId);
					frameId = null;
				}
			},
		};
	};

	const overflowListener = createViewportOverflowListener(LIST_SELECTOR, {
		logWhenOverflowing: false,
		onChange: ({ element, isOverflowingViewport }) => {
			if (!isOverflowingViewport) {
				return;
			}

			$(element)
				.closest('.m-basic-slider')
				.find('.m-slider-navigation__arrow--next')
				.removeAttr('disabled');
		},
	});

	$(window).on('beforeunload.basicSliderOverflowCleanup', () => {
		overflowListener.removeListener();
	});
});

